import { clearModals, modalCounts, popModal, pushModal } from '@ncr-retail/base-retail-components';
import {
  popScannerState,
  pushScannerState,
  resetScannerStates,
  ScannedDataHandler,
} from '../../devices/scanner-operations';
import { pauseWithSpinner, SPINNER_ID } from '../components/with-spinner/with-spinner';

// Any modal does not support scanner should call pushEmeraldModal without passing callBack
// Any modal supports scanner should pass in the callBack function for onDataScanned
// Any modal wants to inherit the former modal states should pass the callback by using getScannerCallback()

export const pushEmeraldModal = (
  modal: JSX.Element,
  scannerCallback?: ScannedDataHandler,
  modalId?: string,
  replaceExisting?: boolean,
): void => {
  if (modalId !== SPINNER_ID) {
    pauseWithSpinner();
    pushScannerState(scannerCallback, modalId);
  }
  pushModal(modal, undefined, modalId, replaceExisting);
};

export const popEmeraldModal = (id?: string): void => {
  if (typeof id === 'string') {
    if (id !== SPINNER_ID) {
      popScannerState(id);
    }
    popModal(id);
  } else {
    popScannerState();
    popModal();
  }
};

export const clearEmeraldModals = (): void => {
  resetScannerStates();
  clearModals();
};

export const emeraldModalCounts = (): number => {
  return modalCounts();
};
